import { FC } from 'react';
import { Alert, AlertTitle, Button } from '@mui/material';
import { Link } from '@vs-online-only-app/ui';

type Props = {
  isOpen: boolean;
  handleClick: () => void;
};

const CreateAccountError: FC<Props> = ({ isOpen, handleClick }) => (
  isOpen && (
    <Alert
      severity="error"
      action={
        <Button onClick={handleClick} sx={{ margin: 'auto' }}>
          Try again
        </Button>
      }
    >
      <AlertTitle>Unable to create account</AlertTitle>
      Please try again. If the problem persists, please{' '}
      <Link to="mailto:support-chat@bamnbuser.com">contact customer care.</Link>
    </Alert>
  )
);

export default CreateAccountError;
